import axios from 'axios';
import { API } from '../api';

export const login = async (credentials) => {
  try {
    const res = await axios.post(API.LOGIN, credentials, { withCredentials: true });
    return res.data;
  } catch (error) {
    console.error('AUTH LOGIN ERROR', error);
    return error.response?.data || { success: false, message: error.message };
  }
};

export const register = async (payload) => {
  try {
    const res = await axios.post(API.REGISTER, payload, { withCredentials: true });
    return res.data;
  } catch (error) {
    console.error('AUTH REGISTER ERROR', error);
    return error.response?.data || { success: false, message: error.message };
  }
};

export const sendOtp = async (email) => {
  try {
    const res = await axios.post(API.SEND_OTP, { email }, { withCredentials: true });
    return res.data;
  } catch (error) {
    console.error('SEND OTP ERROR', error);
    return error.response?.data || { success: false, message: error.message };
  }
};

export const verifyOtp = async (email, otp) => {
  try {
    const res = await axios.post(API.VERIFY_OTP, { email, otp }, { withCredentials: true });
    return res.data;
  } catch (error) {
    console.error('VERIFY OTP ERROR', error);
    return error.response?.data || { success: false, message: error.message };
  }
};

export const sendResetPasswordLink = async (email) => {
  try {
    const res = await axios.post(API.SEND_RESET_PASSWORD_LINK, { email }, { withCredentials: true });
    return res.data;
  } catch (error) {
    console.error('SEND RESET PASSWORD LINK ERROR', error);
    return error.response?.data || { success: false, message: error.message };
  }
};

export const resetPassword = async (payload) => {
  try {
    const res = await axios.post(API.RESET_PASSWORD, payload, { withCredentials: true });
    return res.data;
  } catch (error) {
    console.error('RESET PASSWORD ERROR', error);
    return error.response?.data || { success: false, message: error.message };
  }
};

export const checkAuth = async () => {
  try {
    const res = await axios.get(API.AUTH_CHECK, { withCredentials: true });
    return res.data;
  } catch (error) {
    console.error('AUTH CHECK ERROR', error);
    return error.response?.data || { success: false, message: error.message };
  }
};

export const logout = async () => {
  try {
    const res = await axios.post(API.AUTH_LOGOUT, {}, { withCredentials: true });
    return res.data;
  } catch (error) {
    console.error('AUTH LOGOUT ERROR', error);
    return error.response?.data || { success: false, message: error.message };
  }
};

export const googleLogin = async (credential) => {
  try {
    const res = await axios.post(API.GOOGLE_LOGIN, { credential }, { withCredentials: true });
    return res.data;
  } catch (error) {
    console.error('GOOGLE LOGIN ERROR', error);
    return error.response?.data || { success: false, message: error.message };
  }
};

export const updateProfile = async (payload) => {
  try {
    const res = await axios.post(API.AUTH_UPDATE_PROFILE, payload, { withCredentials: true });
    return res.data;
  } catch (error) {
    console.error('UPDATE PROFILE ERROR', error);
    return error.response?.data || { success: false, message: error.message };
  }
};

export const checkAccountType = async (email) => {
  try {
    const res = await axios.get(API.ACCOUNT_TYPE, { params: { email } });
    return res.data;
  } catch (error) {
    console.error('CHECK ACCOUNT TYPE ERROR', error);
    return error.response?.data || { success: false, message: error.message };
  }
};
